export default function LogoType({ size = "md", className = "" }) {
  const sizes = {
    sm: { fairy: "text-lg", yasha: "text-2xl", gap: "-mt-2" },
    md: { fairy: "text-3xl", yasha: "text-4xl", gap: "-mt-3" },
    xl: { fairy: "text-6xl sm:text-7xl", yasha: "text-7xl sm:text-8xl", gap: "-mt-5 sm:-mt-7" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`leading-none ${className}`}>
      <span className={`block font-display uppercase tracking-[0.18em] text-[#EFE3CC] ${s.fairy}`}>Fairy</span>
      <span className={`block font-script text-gold-gradient ${s.yasha} ${s.gap} pl-1`}>Yasha</span>
    </div>
  );
}
